module.exports = __webpack_public_path__ + "static/img/guard_privilege_icon1.e442879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_privilege_icon1.png
// module id = j8b9
// module chunks = 0